import { createMachine } from "xstate";
import { assign } from "xstate/lib/actions";
import { getUserBook } from "../firebase/firebase.utils";

const mapTimestampsToDates = (insightData) => {
  if (insightData && insightData.readDate && !(insightData.readDate instanceof Date)) {
    insightData.readDate = insightData.readDate.toDate();
  }
  if (insightData && insightData.reviewSchedule && !(insightData.reviewSchedule instanceof Date)) {
    insightData.reviewSchedule = insightData.reviewSchedule.toDate();
  }
  if (insightData && insightData.reviewDate && !(insightData.reviewDate instanceof Date)) {
    insightData.reviewDate = insightData.reviewDate.toDate();
  }
  if (insightData && insightData.finalReviewSchedule && !(insightData.finalReviewSchedule instanceof Date)) {
    insightData.finalReviewSchedule = insightData.finalReviewSchedule.toDate();
  }
  if (insightData && insightData.finalReviewDate && !(insightData.finalReviewDate instanceof Date)) {
    insightData.finalReviewDate = insightData.finalReviewDate.toDate();
  }
  return insightData;
};

const getInsightStage = async (insight) => {
  if (insight === null) return null;
  const _insight = mapTimestampsToDates(insight);
  return _insight;
};

const insightMachine = createMachine({
  id: "insightMachine",
  initial: "initialLoad",
  context: {},
  states: {
    initialLoad: {
      invoke: {
        src: (context, event) => async () =>
          await getInsightStage(context.insight),
        onDone: [
          {
            target: "checkingCycleProgress",
            cond: (context, event) => event.data !== null,
            actions: assign({
              readDate: (context, event) => event.data.readDate,
              reviewSchedule: (context, event) => event.data.reviewSchedule,
              reviewDate: (context, event) => event.data.reviewDate,
              finalReviewSchedule: (context, event) =>
                event.data.finalReviewSchedule,
              finalReviewDate: (context, event) => event.data.finalReviewDate,
            }),
          },
          { target: "readyForFirstTick" },
        ],
      },
    },
    checkingCycleProgress: {
      on: {
        "": [
          {
            target: "completed",
            cond: (context, event) => context.finalReviewDate,
          },
          {
            target: "readyForThirdTick",
            cond: (context, event) =>
              context.reviewDate && new Date() > context.finalReviewSchedule,
          },
          {
            target: "notReadyForThirdTick",
            cond: (context, event) => context.reviewDate,
          },
          {
            target: "readyForSecondTick",
            cond: (context, event) =>
              context.readDate && new Date() > context.reviewSchedule,
          },
          {
            target: "notReadyForSecondTick",
            cond: (context, event) => context.readDate,
          },
          {
            target: "readyForFirstTick",
          },
        ],
      },
    },
    readyForFirstTick: {
      on: {
        TICK: {
          target: "notReadyForSecondTick",
          actions: assign({
            readDate: (context, event) => event.readDate,
            reviewSchedule: (context, event) => event.reviewSchedule,
          }),
        },
        RESET: {
          target: "readyForFirstTick",
        },
      },
    },
    notReadyForSecondTick: {
      on: {
        RESET: {
          target: "readyForFirstTick",
        },
      },
    },
    readyForSecondTick: {
      on: {
        TICK: {
          target: "notReadyForThirdTick",
          actions: assign({
            reviewDate: (context, event) => event.reviewDate,
            finalReviewSchedule: (context, event) => event.finalReviewSchedule,
          }),
        },
        RESET: {
          target: "readyForFirstTick",
        },
      },
    },
    notReadyForThirdTick: {
      on: {
        RESET: {
          target: "readyForFirstTick",
        },
      },
    },
    readyForThirdTick: {
      on: {
        TICK: {
          target: "completed",
          actions: assign({
            finalReviewDate: (context, event) => event.finalReviewDate,
          }),
        },
        RESET: {
          target: "readyForFirstTick",
        },
      },
    },
    completed: {
      on: {
        RESET: {
          target: "readyForFirstTick",
        },
      },
    },
  },
});

export default insightMachine;
